import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, mergeProps as _mergeProps } from "vue";
const _hoisted_1 = ["disabled", "title"];
const _hoisted_2 = {
    key: 0,
    class: "d-flex justify-content-center align-items-center w-100 h-100 position-absolute top-0 start-0"
};
const _hoisted_3 = { key: 1 };
const _hoisted_4 = ["title", "disabled"];
const _hoisted_5 = {
    key: 0,
    class: "d-flex justify-content-center align-items-center w-100 h-100 position-absolute top-0 start-0"
};
const _hoisted_6 = { key: 1 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_ctx.action !== 'click')
        ? (_openBlock(), _createElementBlock("button", _mergeProps({ key: 0 }, _ctx.$attrs, {
            class: ['btn', _ctx.cssClass, _ctx.cssStyle],
            disabled: _ctx.isDisabled,
            title: _ctx.title,
            onClick: _cache[0] || (_cache[0] =
                //@ts-ignore
                (...args) => (_ctx.OnClickInternal && _ctx.OnClickInternal(...args)))
        }), [
            (_ctx.isLoadingInternal)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[1] || (_cache[1] = [
                        _createElementVNode("span", {
                            class: "spinner-border spinner-border-sm",
                            role: "status",
                            "aria-hidden": "true"
                        }, null, -1)
                    ]))]))
                : _createCommentVNode("", true),
            (_ctx.text)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.text), 1))
                : _renderSlot(_ctx.$slots, "default", { key: 2 })
        ], 16, _hoisted_1))
        : (_openBlock(), _createElementBlock("button", _mergeProps({ key: 1 }, _ctx.$attrs, {
            style: { "position": "relative" },
            class: ['btn', _ctx.cssClass, _ctx.cssStyle],
            title: _ctx.title,
            disabled: _ctx.isDisabled
        }), [
            (_ctx.isLoadingInternal)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[2] || (_cache[2] = [
                        _createElementVNode("span", {
                            class: "spinner-border spinner-border-sm",
                            role: "status",
                            "aria-hidden": "true"
                        }, null, -1)
                    ]))]))
                : _createCommentVNode("", true),
            (_ctx.text)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.text), 1))
                : _renderSlot(_ctx.$slots, "default", { key: 2 })
        ], 16, _hoisted_4));
}
